import {getAuth, getInsurerId, getSubscribeStatus, isInsurer} from '../Actions/authAction';

export default (state) => {
    return {
        auth: () => {
            return getAuth();
        },
        loginState: () => {
            return state.auth.loggedIn;
        },
        robotLoginState: () => {
            return state.auth.robotLoggedIn;
        },
        tdLoginState: () => {
            return state.auth.tdLoggedIn;
        },
        validationState: () => {
            return state.auth.validationStatus;
        },
        secretDetails: () => {
            return state.auth.secretDetails;
        },
		forgotPasswordEmailState: () => {
			return state.auth.forgotPasswordEmailStatus;
		},
		resetPasswordState: () => {
			return state.auth.resetPasswordStatus;
		},
        updateUserState: () => {
            return state.auth.updateUserStatus;
        },
        isInsurer: () => {
            return isInsurer();
        },
        authState: () => {
            return state.auth;
        },
        insurerId: () => {
            return getInsurerId();
        },
        subscribe: () => {
            return getSubscribeStatus();
        }
    };
}



// WEBPACK FOOTER //
// ./src/ReduxRequests/State/authState.ts